import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import { isObjectLike, toJSON, compareCollection, mapProperties } from '@dateam/ark';
var NavigationRoute = /*#__PURE__*/function () {
  function NavigationRoute(key) {
    var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var params = arguments.length > 2 ? arguments[2] : undefined;
    var state = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, NavigationRoute);
    this.key = void 0;
    this.format = void 0;
    this.params = void 0;
    this.state = void 0;
    this.metadata = void 0;
    this.key = key;
    this.format = format;
    this.params = params;
    this.state = state;
  }
  return _createClass(NavigationRoute, [{
    key: "addMetadata",
    value: function addMetadata(metadata) {
      if (isObjectLike(metadata)) this.metadata = metadata;
      return this;
    }
  }, {
    key: "toPath",
    value: function toPath(router) {
      var path = router.getPath.apply(router, [this.key].concat(_toConsumableArray(this.format)));
      if (isObjectLike(this.params) && Object.keys(this.params).length > 0) {
        var params = mapProperties(this.params, function (value, key) {
          return "".concat(key, "=").concat(value);
        });
        path += "?".concat(params.join('&'));
      }
      return path;
    }
  }, {
    key: "compareRoute",
    value: function compareRoute(withRoute) {
      if (!(withRoute instanceof NavigationRoute)) return false;
      return this.key === withRoute.key && compareCollection(this.format, withRoute.format).length === 0 && toJSON(this.params) === toJSON(withRoute.params);
    }
  }, {
    key: "comparePath",
    value: function comparePath(withPath, router) {
      return this.toPath(router) === withPath;
    }
  }]);
}();
export { NavigationRoute as default };